import { render, staticRenderFns } from "./search-title.vue?vue&type=template&id=2e3de4ad&scoped=true"
import script from "./search-title.vue?vue&type=script&lang=js"
export * from "./search-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3de4ad",
  null
  
)

export default component.exports